export const TIMEZONE = [
  {
    timezone: 'Pacific/Majuro',
    UTC: '+12',
    area: 'australasia',
    longitude: 171.38,
  },
  {
    timezone: 'Pacific/Midway',
    UTC: '-11',
    area: 'australasia',
    longitude: -87.006,
  },
  {
    timezone: 'Pacific/Honolulu',
    UTC: '-10',
    area: 'northamerica',
    longitude: -77.282,
  },
  {
    timezone: 'America/Anchorage',
    UTC: '-9',
    area: 'northamerica',
    longitude: -149.25,
  },
  {
    timezone: 'America/Los_Angeles',
    UTC: '-8',
    area: 'northamerica',
    longitude: -118.24,
  },
  {
    timezone: 'America/Tijuana',
    UTC: '-8',
    area: 'northamerica',
    longitude: -117,
  },
  {
    timezone: 'America/Phoenix',
    UTC: '-7',
    area: 'northamerica',
    longitude: -112.07,
  },
  {
    timezone: 'America/Chihuahua',
    UTC: '-6',
    area: 'northamerica',
    longitude: -106.25,
  },
  {
    timezone: 'America/Denver',
    UTC: '-7',
    area: 'northamerica',
    longitude: -104.98,
  },
  {
    timezone: 'America/Costa_Rica',
    UTC: '-6',
    area: 'northamerica',
    longitude: -84,
  },
  {
    timezone: 'America/Chicago',
    UTC: '-6',
    area: 'northamerica',
    longitude: -87.65,
  },
  {
    timezone: 'America/Mexico_City',
    UTC: '-6',
    area: 'northamerica',
    longitude: -102,
  },
  {
    timezone: 'America/Regina',
    UTC: '-6',
    area: 'northamerica',
    longitude: -104.62,
  },
  {
    timezone: 'America/Bogota',
    UTC: '-5',
    area: 'southamerica',
    longitude: -74.08,
  },
  {
    timezone: 'America/New_York',
    UTC: '-5',
    area: 'northamerica',
    longitude: -74.01,
  },
  {
    timezone: 'America/Caracas',
    UTC: '-4',
    area: 'southamerica',
    longitude: -66.88,
  },
  {
    timezone: 'America/Barbados',
    UTC: '-4',
    area: 'northamerica',
    longitude: -59.55,
  },
  {
    timezone: 'America/Halifax',
    UTC: '-4',
    area: 'northamerica',
    longitude: -63.58,
  },
  {
    timezone: 'America/Manaus',
    UTC: '-4',
    area: 'southamerica',
    longitude: -60.03,
  },
  {
    timezone: 'America/Santiago',
    UTC: '-3',
    area: 'southamerica',
    longitude: -70.65,
  },
  {
    timezone: 'America/St_Johns',
    UTC: '-3:30',
    area: 'northamerica',
    longitude: -52.71,
  },
  {
    timezone: 'America/Sao_Paulo',
    UTC: '-3',
    area: 'southamerica',
    longitude: -46.64,
  },
  {
    timezone: 'America/Argentina/Buenos_Aires',
    UTC: '-3',
    area: 'southamerica',
    longitude: -58.38,
  },
  {
    timezone: 'America/Godthab',
    UTC: '-2',
    area: 'europe',
    longitude: -51.721,
  },
  {
    timezone: 'America/Montevideo',
    UTC: '-3',
    area: 'southamerica',
    longitude: -56.183,
  },
  {
    timezone: 'Atlantic/South_Georgia',
    UTC: '-2',
    area: 'southamerica',
    longitude: -36.7,
  },
  {
    timezone: 'Atlantic/Azores',
    UTC: '-1',
    area: 'europe',
    longitude: -25.67,
  },
  {
    timezone: 'Atlantic/Cape_Verde',
    UTC: '-1',
    area: 'africa',
    longitude: -23.5,
  },
  {
    timezone: 'Africa/Casablanca',
    UTC: '+1',
    area: 'africa',
    longitude: -7.617,
  },
  {
    timezone: 'Europe/London',
    UTC: '+0',
    area: 'europe',
    longitude: -0.1278,
  },
  {
    timezone: 'Europe/Amsterdam',
    UTC: '+1',
    area: 'europe',
    longitude: 4.8897,
  },
  {
    timezone: 'Europe/Belgrade',
    UTC: '+1',
    area: 'europe',
    longitude: 20.4569,
  },
  {
    timezone: 'Europe/Brussels',
    UTC: '+1',
    area: 'europe',
    longitude: 4.3488,
  },
  {
    timezone: 'Europe/Sarajevo',
    UTC: '+1',
    area: 'europe',
    longitude: 18.3564,
  },
  {
    timezone: 'Africa/Windhoek',
    UTC: '+2',
    area: 'africa',
    longitude: 17.0832,
  },
  {
    timezone: 'Africa/Brazzaville',
    UTC: '+1',
    area: 'africa',
    longitude: 15.2832,
  },
  {
    timezone: 'Asia/Amman',
    UTC: '+3',
    area: 'asia',
    longitude: 35.9106,
  },
  {
    timezone: 'Europe/Athens',
    UTC: '+2',
    area: 'europe',
    longitude: 23.7294,
  },
  {
    timezone: 'Asia/Beirut',
    UTC: '+2',
    area: 'asia',
    longitude: 35.5131,
  },
  {
    timezone: 'Africa/Cairo',
    UTC: '+2',
    area: 'africa',
    longitude: 31.2358,
  },
  {
    timezone: 'Europe/Helsinki',
    UTC: '+2',
    area: 'europe',
    longitude: 24.9384,
  },
  {
    timezone: 'Asia/Jerusalem',
    UTC: '+2',
    area: 'asia',
    longitude: 35.2131,
  },
  {
    timezone: 'Europe/Minsk',
    UTC: '+3',
    area: 'europe',
    longitude: 27.5667,
  },
  {
    timezone: 'Africa/Harare',
    UTC: '+2',
    area: 'africa',
    longitude: 31.0534,
  },
  {
    timezone: 'Asia/Baghdad',
    UTC: '+3',
    area: 'asia',
    longitude: 44.3661,
  },
  {
    timezone: 'Europe/Moscow',
    UTC: '+3',
    area: 'europe',
    longitude: 37.6176,
  },
  {
    timezone: 'Asia/Kuwait',
    UTC: '+3',
    area: 'asia',
    longitude: 47.9774,
  },
  {
    timezone: 'Africa/Nairobi',
    UTC: '+3',
    area: 'africa',
    longitude: 36.8172,
  },
  {
    timezone: 'Asia/Tehran',
    UTC: '+3:30',
    area: 'asia',
    longitude: 51.389,
  },
  {
    timezone: 'Asia/Baku',
    UTC: '+4',
    area: 'asia',
    longitude: 49.8671,
  },
  {
    timezone: 'Asia/Tbilisi',
    UTC: '+4',
    area: 'asia',
    longitude: 44.8271,
  },
  {
    timezone: 'Asia/Yerevan',
    UTC: '+4',
    area: 'asia',
    longitude: 44.5144,
  },
  {
    timezone: 'Asia/Dubai',
    UTC: '+4',
    area: 'asia',
    longitude: 55.296249,
  },
  {
    timezone: 'Asia/Kabul',
    UTC: '+4:30',
    area: 'asia',
    longitude: 69.1658,
  },
  {
    timezone: 'Asia/Karachi',
    UTC: '+5',
    area: 'asia',
    longitude: 67.0011,
  },
  {
    timezone: 'Asia/Oral',
    UTC: '+5',
    area: 'asia',
    longitude: 51.3667,
  },
  {
    timezone: 'Asia/Yekaterinburg',
    UTC: '+5',
    area: 'europe',
    longitude: 60.6057,
  },
  {
    timezone: 'Asia/Calcutta',
    UTC: '+5:30',
    area: 'asia',
    longitude: 88.363,
  },
  {
    timezone: 'Asia/Colombo',
    UTC: '+5:30',
    area: 'asia',
    longitude: 79.8612,
  },
  {
    timezone: 'Asia/Katmandu',
    UTC: '+5:45',
    area: 'asia',
    longitude: 85.3333,
  },
  {
    timezone: 'Asia/Almaty',
    UTC: '+5',
    area: 'asia',
    longitude: 76.8897,
  },
  {
    timezone: 'Asia/Rangoon',
    UTC: '+6:30',
    area: 'asia',
    longitude: 96.16,
  },
  {
    timezone: 'Asia/Krasnoyarsk',
    UTC: '+7',
    area: 'europe',
    longitude: 92.8932,
  },
  {
    timezone: 'Asia/Bangkok',
    UTC: '+7',
    area: 'asia',
    longitude: 100.5018,
  },
  {
    timezone: 'Asia/Shanghai',
    UTC: '+8',
    area: 'asia',
    longitude: 121.4737,
  },
  {
    timezone: 'Asia/Hong_Kong',
    UTC: '+8',
    area: 'asia',
    longitude: 114.1694,
  },
  {
    timezone: 'Asia/Irkutsk',
    UTC: '+8',
    area: 'europe',
    longitude: 104.2833,
  },
  {
    timezone: 'Asia/Kuala_Lumpur',
    UTC: '+8',
    area: 'asia',
    longitude: 101.4143,
  },
  {
    timezone: 'Australia/Perth',
    UTC: '+8',
    area: 'australasia',
    longitude: 115.8605,
  },
  {
    timezone: 'Asia/Taipei',
    UTC: '+8',
    area: 'asia',
    longitude: 121,
  },
  {
    timezone: 'Asia/Seoul',
    UTC: '+9',
    area: 'asia',
    longitude: 126.978,
  },
  {
    timezone: 'Asia/Tokyo',
    UTC: '+9',
    area: 'asia',
    longitude: 139.759455,
  },
  {
    timezone: 'Asia/Yakutsk',
    UTC: '+9',
    area: 'europe',
    longitude: 129.7331,
  },
  {
    timezone: 'Australia/Adelaide',
    UTC: '+10:30',
    area: 'australasia',
    longitude: 138.5986,
  },
  {
    timezone: 'Australia/Darwin',
    UTC: '+9:30',
    area: 'australasia',
    longitude: 130.8333,
  },
  {
    timezone: 'Australia/Brisbane',
    UTC: '+10',
    area: 'australasia',
    longitude: 153.0251,
  },
  {
    timezone: 'Australia/Hobart',
    UTC: '+11',
    area: 'australasia',
    longitude: 147.325,
  },
  {
    timezone: 'Australia/Sydney',
    UTC: '+11',
    area: 'australasia',
    longitude: 151.21111,
  },
  {
    timezone: 'Asia/Vladivostok',
    UTC: '+10',
    area: 'europe',
    longitude: 131.8833,
  },
  {
    timezone: 'Pacific/Guam',
    UTC: '+10',
    area: 'australasia',
    longitude: 144.7937,
  },
  {
    timezone: 'Asia/Magadan',
    UTC: '+11',
    area: 'europe',
    longitude: 150.8,
  },
  {
    timezone: 'Pacific/Auckland',
    UTC: '+13',
    area: 'australasia',
    longitude: 174.7633,
  },
  {
    timezone: 'Pacific/Fiji',
    UTC: '+12',
    area: 'australasia',
    longitude: 178.065,
  },
  {
    timezone: 'Pacific/Tongatapu',
    UTC: '+13',
    area: 'australasia',
    longitude: -175.1982,
  },
  {
    timezone: 'Asia/Singapore',
    UTC: '+8',
    area: 'asia',
    longitude: 103.85,
  },
  {
    timezone: 'Asia/Macau',
    UTC: '+8',
    area: 'asia',
    longitude: 113.5442,
  },
]

export const CONTINENT = [
  'asia',
  'australasia',
  'europe',
  'northamerica',
  'southamerica',
  'africa',
]
